import { accessRole } from "../../../../helpers/access_role"
import classnames from 'classnames'
import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap"

import moment from "moment"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { Link } from 'react-router-dom'

import Select from "react-select"
import YearSelect from '../../../../helpers/ui/YearSelect';
import Shimmer from "react-shimmer-effect";

// import TableActiveComponent from './Components/TableActiveComponent'
import TableComponent from './Components/TableComponent'
import TableManualComponent from './Components/TableManualComponent'
// import IndexBloc from "./Blocs/IndexBloc"

const IndexView = (props) => {
    const currentRoleId = localStorage.getItem('currentRoleId') ? JSON.parse(localStorage.getItem('currentRoleId')) : {};
    const activeRef = useRef();
    const inactiveRef = useRef();
    const secondRef = useRef();

    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()
    const [activeTab, setactiveTab] = useState("1")
    const toggle = (tab) => {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadSecondRef = () => secondRef.current.setTokenAPI()


    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        
                        <CardTitle>Hukuman Disiplin</CardTitle>
                        <CardSubtitle className="mb-3">
                            {/* Daftar Urut Kepangkatan */}
                        </CardSubtitle>
                        <hr/>

                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeTab === "1",
                                        })}
                                        onClick={() => {
                                            toggle("1")
                                        }}
                                    >
                                        <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                        <span className="d-none d-sm-block">Periode Hukuman Disiplin</span>
                                    </NavLink>
                                </NavItem>
                            {
                                (accessRole('create') && currentRoleId == 1) ?
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                        active: activeTab === "2",
                                            })}
                                        onClick={() => {
                                            toggle("2")
                                        }}
                                    >
                                        <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                        <span className="d-none d-sm-block">Manual Hukuman Disiplin</span>
                                    </NavLink>
                                </NavItem>
                                :''
                            }
                            </Nav>

                            <TabContent activeTab={activeTab} className="p-3 text-muted">
                                <TabPane tabId="1">
                                    <div className="float-end">
                                    {
                                        (accessRole('create') && currentRoleId == 1) ?
                                            <Link to="?create">
                                                <Button color="primary">Tambah Periode</Button>
                                            </Link>
                                        : null
                                    }
                                    </div>
                                    <br />
                                    <br />
                                    <hr />
                                    <br />
                                    <TableComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} currentRoleId={currentRoleId}/>
                                </TabPane>
                                <TabPane tabId="2">
                                    {/* <TableSecondComponent ref={secondRef} /> */}
                                    <div className="float-end">
                                    {
                                        (accessRole('create') && currentRoleId == 1) ?
                                            <Link to="?create_manual_hukdis">
                                                <Button color="primary">Tambah Hukuman Disiplin Manual</Button>
                                            </Link>
                                        : null
                                    }
                                    </div>
                                    <br />
                                    <br />
                                    <hr />
                                    <br />
                                    <TableManualComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} currentRoleId={currentRoleId}/>
                                    {/* Hukdis manual */}
                                </TabPane>
                            </TabContent>

                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )
}

export default IndexView;